/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Email_PlaceholderInputs */

const en_signin_email_placeholder = /** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`name@company.com`)
};

/** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */
const ar_signin_email_placeholder = en_signin_email_placeholder;

/** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */
const he_signin_email_placeholder = en_signin_email_placeholder;

/** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */
const ur_signin_email_placeholder = en_signin_email_placeholder;

/** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */
const es_signin_email_placeholder = en_signin_email_placeholder;

/** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */
const fr_signin_email_placeholder = en_signin_email_placeholder;

/** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */
const de_signin_email_placeholder = en_signin_email_placeholder;

/** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */
const pt_signin_email_placeholder = en_signin_email_placeholder;

/** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */
const hi_signin_email_placeholder = en_signin_email_placeholder;

/** @type {(inputs: Signin_Email_PlaceholderInputs) => LocalizedString} */
const bn_signin_email_placeholder = en_signin_email_placeholder;

/**
* | output |
* | --- |
* | "name@company.com" |
*
* @param {Signin_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_email_placeholder = /** @type {((inputs?: Signin_Email_PlaceholderInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Email_PlaceholderInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_email_placeholder(inputs)
	if (locale === "he") return he_signin_email_placeholder(inputs)
	if (locale === "ur") return ur_signin_email_placeholder(inputs)
	if (locale === "es") return es_signin_email_placeholder(inputs)
	if (locale === "fr") return fr_signin_email_placeholder(inputs)
	if (locale === "de") return de_signin_email_placeholder(inputs)
	if (locale === "pt") return pt_signin_email_placeholder(inputs)
	if (locale === "hi") return hi_signin_email_placeholder(inputs)
	if (locale === "bn") return bn_signin_email_placeholder(inputs)
	return /** @type {LocalizedString} */ ("name@company.com")
});